module.exports = "/images/data-preview@3x.png?4b264f1b612c0e6f8900adb8b7307a25";